import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useAppContext } from "store/context";
import Splash from "components/Splash";

const Callback = () => {
  const history = useHistory();
  const { firebase, station } = useAppContext();

  useEffect(() => {
    const signIn = async () => {
      const values = queryString.parse(window.location.search);
      const { user } = await firebase.auth().signInWithCustomToken(decodeURIComponent(values.token));
      if (user) {
        try {
          await firebase.firestore().collection("devices").doc(station.id).update({
            device_detail: station.device_detail,
          });

          history.push("/");
        } catch (e) {
          console.error(e);
          history.push("/error");
        }
      }
    };
    signIn();
  }, [firebase, history, station]);

  return <Splash />;
};

export default Callback;
